import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import drywallService from './drywallService'

const initialState = {
	drywall: [],
	isError: false,
	isSuccess: false,
	isLoading: false,
	message: '',
}

export const getDrywall = createAsyncThunk('images/getDrywall', async (thunkAPI) => {
	try {
		return await drywallService.getDrywall()
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString()

		return thunkAPI.rejectWithValue(message)
	}
})

export const drywallSlice = createSlice({
	name: 'drywall',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getDrywall.pending, (state) => {
				state.isLoading = true
			})
			.addCase(getDrywall.fulfilled, (state, action) => {
				state.isLoading = false
				state.isSuccess = true
				state.drywall = action.payload
			})
			.addCase(getDrywall.rejected, (state, action) => {
				state.isLoading = false
				state.isError = true
				state.drywall = []
				state.message = action.payload
			})
	},
})

export default drywallSlice.reducer
